import { useState } from 'react'
import { DeleteMapButton } from 'ui-components'
import { useDeleteMap } from '~map-settings/query/useDeleteMap'
import { useRouter } from 'next/router'
import { useMap } from '~map-preview/states/map'
import { getWorkspaceLink } from 'utils'
export const DeleteMap = () => {
  const router = useRouter()
  const map = useMap()
  const { mutateAsync } = useDeleteMap()
  const [isLoading, setIsLoading] = useState(false)
  const handleDeleteMap = async () => {
    await mutateAsync(map.id)
    router.push(
      getWorkspaceLink({
        workspaceId: map.workspace.id,
        workspaceName: map.workspace.name
      })
    )
    setIsLoading(true)
  }
  return (
    <DeleteMapButton
      isLoading={isLoading}
      onClick={handleDeleteMap}
    />
  )
}
